import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getMailProfile, updateMailProfile } from "../api";
import { useNotification } from "../../../contexts/NotificationContext";

export const useGetMailProfile = (id) => {
    return useQuery({
        queryKey: ['mail-profile', id],
        queryFn: () => getMailProfile(id),
        enabled: !!id,
    });
};

export const useUpdateMailProfile = () => {
    const queryClient = useQueryClient();
    const { showNotification } = useNotification();

    return useMutation({
        mutationFn: (data) => updateMailProfile(data),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["mail-profile"] });
            showNotification('success', 'Email settings updated successfully!');
        },
        onError: (error) => {
            console.error("Error updating email settings:", error);
            let errorMessage = 'Error updating email settings. Please try again.';
            if (error?.response?.data?.error?.message) {
                errorMessage = error.response.data.error.message;
            } else if (error?.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error?.message) {
                errorMessage = error.message;
            }
            showNotification('danger', errorMessage);
        },
    });
};
